import React from 'react';
import { withRouter } from 'react-router';

import FileCore from './file-core';
import DropdownBtn from './dropdown-btn';
import FileUpload from './file-upload';

import Placeholder from './placeholders/attachment-thumb.placeholder';

import IconDiscussionAlt from '../icons/icon-discussion-alt';
import IconRemove from '../icons/icon-remove';
import IconPlus from '../icons/icon-plus';

class AttachmentThumb extends FileCore {
    handleRemoveButtonClick = () => {
        this.props.onRemoveButtonClick && this.props.onRemoveButtonClick(this.props.id);
    }

    get iconElement() {
        return <span className="attachment-icon">{this.fileIconElement}</span>;
    }

    get errorElement() {
        return <div className="attachment-icon">
            <i className="material-icons">error_outline</i>

            <img src={this.thumbnailUrl} onLoad={this.handleImageLoad} style={{position: 'absolute', visibility: 'hidden'}} alt={this.props.name} />
        </div>;
    }

    get previewElement() {
        return <img onLoad={this.props.onLoad} className="attachment-preview" src={this.props.thumbnail || this.props.url} alt="Attachment" />
    }

    render() {
        if (this.props.placeholder || this.props.loading || this.state.postProcessLoading) {
            return <Placeholder />;
        }

        if (this.props.new) {
            return (
                <div className="attachment-thumb clickable">
                    <FileUpload onChange={this.props.onFileAdd}>
                        <div className="attachment-main">
                            <div className="attachment-icon-holder">
                                <IconPlus size="40px" />
                            </div>
                        </div>
                    </FileUpload>
                </div>
            );
        }

        if ((!this.props.google_type && !this.props.download) && !this.props.removed && !this.props.error) {
            return (
                <div className="attachment-thumb clickable" onClick={this.handleRetryClick}>
                    <div className="attachment-main">
                        <span className="attachment-icon-holder">
                            <i className="icon material-icons">autorenew</i>

                            <span>Retry</span>
                        </span>
                    </div>
                </div>
            )
        }

        if (this.props.error) {
            return (
                <div className="attachment-thumb">
                    <div className="attachment-main">
                        {this.errorElement}
                    </div>
                </div>
            )
        }

        if (this.props.removed) {
            return null;
        }

        return (
            <div className={'attachment-thumb' + (this.state && this.state.dropdownVisible ? ' action-dropdown-visible' : '')}>
                <div className="attachment-main">
                    {this.filePreviewElement}

                    <div className="attachment-overlay" onClick={this.props.onClick || this.handleClick} />

                    <div className="attachment-actions">
                        {
                            this.props.withDownload ? (
                                <div className="action-item">
                                    <a href={this.props.download || this.props.url} download={this.props.name} target="_blank" rel="noreferrer" onClick={this.handleDownload} className="btn btn-simple btn-small btn-square btn-icon">
                                        <i className="material-icons">file_download</i>
                                    </a>
                                </div>
                            ) : null
                        }

                        {
                            this.props.withComment ? (
                                <div className="action-item">
                                    <button className="btn btn-simple btn-small btn-square btn-icon" onClick={this.props.onClick || this.handleCommentsClick}>
                                        <IconDiscussionAlt />
                                    </button>
                                </div>
                            ) : null
                        }

                        {
                            this.props.withUtils ? (
                                <div className="action-item">
                                    <DropdownBtn
                                        btnClassName="btn btn-simple btn-small btn-square btn-icon"
                                        items={this.utilItems}
                                        onDropdownShow={this.handleDropdownExpand}
                                        onDropdownHide={this.handleDropdownCollapse}
                                        onItemClick={this.handleUtilClick}
                                    >
                                        <i className="material-icons">more_horiz</i>
                                    </DropdownBtn>
                                </div>
                            ) : null
                        }

                        {
                            this.props.onRemoveButtonClick ? (
                                <div className="action-item">
                                    <button className="btn btn-simple btn-small btn-square btn-icon" onClick={this.handleRemoveButtonClick}>
                                        <IconRemove />
                                    </button>
                                </div>
                            ) : null
                        }
                    </div>

                    {
                        this.props.comments ? (
                            <div className={'attachment-comments' + (this.props.notifications.length ? ' with-unread' : '')} onClick={this.props.onClick || this.handleCommentsClick}>
                                <i className="material-icons">chat</i>

                                {this.props.comments}
                            </div>
                        ) : (
                            null
                        )
                    }
                </div>

                <div className="attachment-meta">
                    <span className="collapsable" title={this.props.name}>{this.props.name}</span>

                    {
                        !this.props.google_type ? <span>{this.fileSize}</span> : null
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(AttachmentThumb);
